<!-- 聊天输入面板 -->
<template>
  <div class="chat-input-panel">
    <!-- 常用提示词栏 -->
    <div class="top-block">
      <transition v-loading="loading" appear name="fade-slide">
        <div v-show="!isShowMyCommon" class="template-list">
          <!-- 常用提示词列表 -->
          <div
            v-if="allPromptList.length"
            ref="templateListWrapperRef"
            class="template-list-wrapper"
          >
            <div
              v-for="(item, index) in allPromptList"
              :key="index"
              class="template-item"
              :class="{
                'active-item': currentIndex === index
              }"
              @click="selectTemplate(item)"
            >
              <!-- 2026.6.11 激活提示词高亮 这里可能存在问题 -->
              <img alt="AI生成图标" src="@/assets/chat-1-line.svg" />
              <span class="ellipsis text-color-main text-normal-4">{{ item.name }}</span>
            </div>
            <!-- 左翻页按钮 -->
            <div
              class="page-btn page-btn--left"
              :class="{
                'page-btn--hidden': !canPageLeft
              }"
            >
              <i
                class="icon-arrow-left-s-line page-btn__icon t-iconfont"
                :class="{ 'page-btn__icon--disabled': isPageChanging }"
                @click="handlePageChange(false)"
              />
            </div>
          </div>

          <!-- 更多分析场景 -->
          <div class="more">
            <!-- 右翻页按钮 -->
            <div
              class="page-btn page-btn--right"
              :class="{
                'page-btn--hidden': !canPageRight
              }"
            >
              <i
                class="icon-arrow-right-s-line page-btn__icon t-iconfont"
                :class="{ 'page-btn__icon--disabled': isPageChanging }"
                @click="handlePageChange(true)"
              />
            </div>
            <!-- 打开常用提示词弹窗 -->
            <i
              v-if="pageHelper && pageHelper.rowsCount >= 3"
              class="icon-expand-diagonal-line t-iconfont text-color-auxiliary"
              @click="handleOpenCommonDialog"
            />
            <div v-if="pageHelper && pageHelper.rowsCount" class="line"></div>
            <!-- 更多分析场景 -->
            <div class="template-item" style="width: 140px" @click="emits('show-more')">
              <i class="icon-sparkling-2-line t-iconfont" />
              <span class="more-text">更多分析场景</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 常用提示词弹窗 -->
    <dialog-common-used
      v-if="isShowMyCommon"
      v-model:show="isShowMyCommon"
      @setPrompt="handleSetPrompt"
    />

    <div class="main">
      <!-- 上传文件 -->
      <div v-if="uploadedFiles.length" class="uploaded-file-strip">
        <div ref="uploadedFileListRef" class="uploaded-file-list" @scroll="updateFilePageButton">
          <UploadedFileCard
            v-for="(file, index) in uploadedFiles"
            :key="file.attachIndex || file.id || index"
            :file="file"
            @delete="handleDeleteUploadedFile"
          />
        </div>
        <div
          class="uploaded-file-page-btn uploaded-file-page-btn--left"
          :class="{ 'uploaded-file-page-btn--hidden': !canFilePageLeft }"
        >
          <i
            class="icon-arrow-left-s-line t-iconfont uploaded-file-page-btn__icon"
            :class="{ 'uploaded-file-page-btn__icon--disabled': isFilePageChanging }"
            @click="handleFilePageLeft"
          />
        </div>
        <div
          class="uploaded-file-page-btn uploaded-file-page-btn--right"
          :class="{ 'uploaded-file-page-btn--hidden': !canFilePageRight }"
        >
          <i
            class="icon-arrow-right-s-line t-iconfont uploaded-file-page-btn__icon"
            :class="{ 'uploaded-file-page-btn__icon--disabled': isFilePageChanging }"
            @click="handleFilePageRight"
          />
        </div>
      </div>
      <!-- 输入区域 -->
      <div v-if="polishLoading" class="content-skeleton">
        <el-skeleton animated>
          <template #template>
            <!-- 取消一下骨架屏自动高度 未来需要可以接入 :style="{ height: `${skeletonHeight}px` }" -->
            <div class="content-skeleton__rows">
              <el-skeleton-item class="content-skeleton__row" variant="text" />
              <el-skeleton-item
                class="content-skeleton__row content-skeleton__row--short"
                variant="text"
              />
            </div>
          </template>
        </el-skeleton>
      </div>
      <el-input
        v-else
        ref="elInputRef"
        v-model="analystContentModel"
        :autosize="{ minRows: 3, maxRows: 8 }"
        class="content-input"
        :maxlength="wordLimit"
        placeholder="⏎ 回车键发送 / Ctrl(⌘) + ⏎ 换行"
        type="textarea"
        @input="checkChangeAiPrompt"
        @keydown="keydownChatInput"
      />
      <!-- 字数超限提示 -->
      <div v-if="isWordLimit" class="word-count">
        <p class="word-count--text">
          <span class="word-count--red">{{ analystContentModel.length }} </span> /
          {{ wordLimit }}
        </p>
      </div>

      <!-- 筛选条件和发送按钮 -->
      <div class="input-footer">
        <div class="filter-section">
          <div class="filter-section-left">
            <!-- 文件上传 -->
            <el-tooltip effect="dark" placement="top">
              <template #content>
                上传文件（总文件不超过 {{ uploadSize }}MB）<br />支持 {{ UPLOAD_TEXT }} 格式
              </template>
              <div class="upload-btn" @click="clickUpload">
                <i class="icon-add-line t-iconfont" />
              </div>
            </el-tooltip>
            <div class="deco"></div>
            <input
              ref="uploadInputRef"
              :accept="UPLOAD_ACCEPT"
              hidden
              multiple
              type="file"
              @change="handleUploadInputChange"
            />
            <!-- 联网 -->
            <button
              v-if="isWhite"
              class="network-btn"
              :class="{ active: enableSearchModel }"
              type="button"
              @click="toggleNetworkEnabled"
            >
              <i class="icon-global-line t-iconfont" />
              <span>联网</span>
            </button>
            <!-- 分析类型 -->
            <div class="filter-section__item" style="width: 104px">
              <el-select
                :model-value="analysisBusinessTypeModel"
                placeholder="请选择分析类型"
                @change="switchAnalysisBusinessType"
              >
                <el-option
                  v-for="item in analysisBusinessTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <!-- 是否业务数据来源  -->
            <template v-if="isBusinessTypeDataSource">
              <div class="filter-section__item" style="width: 128px">
                <ai-condition prefix="icon-pass-pending-line">
                  <template #content>
                    <CustomerSelectDialog
                      v-model="customerModel"
                      :business-type="analysisBusinessTypeModel"
                    ></CustomerSelectDialog>
                  </template>
                </ai-condition>
              </div>
            </template>
            <!-- 是否员工数据来源\陪练分析来源 -->
            <template v-else-if="[0, 1].includes(analysisBusinessTypeModel)">
              <div class="filter-section__item">
                <ai-condition prefix="icon-user-line" style="width: 128px">
                  <template #content>
                    <AiPersonSelectV2 v-model:range-value="selectValueModel" :max="200" />
                  </template>
                </ai-condition>
              </div>
              <!-- 员工分析展示时间，客户分析不展示 -->
              <div class="filter-section__item" style="width: 128px">
                <ai-condition>
                  <template #content>
                    <el-tooltip
                      :content="dateRangeDisplayText"
                      :disabled="!dateRangeDisplayText"
                      effect="dark"
                      placement="top"
                    >
                      <div
                        class="date-range-picker"
                        :class="{ 'date-range-picker--has-value': dateRangeDisplayText }"
                      >
                        <el-date-picker
                          v-model="dateScopeModel"
                          :clearable="false"
                          :disabled-date="disabledDate"
                          end-placeholder="结束时间"
                          range-separator="～"
                          :shortcuts="shortcuts"
                          start-placeholder="开始时间"
                          type="daterange"
                          unlink-panels
                        />
                        <span v-if="dateRangeDisplayText" class="date-range-picker__display">
                          {{ dateRangeDisplayText }}
                        </span>
                      </div>
                    </el-tooltip>
                  </template>
                </ai-condition>
              </div>
            </template>
          </div>
        </div>

        <template v-if="!canSend">
          <!-- 内容正在输出，优先展示终止分析 -->
          <el-tooltip content="终止分析" effect="dark" placement="top">
            <div class="send-btn" @click="handleSend">
              <i class="icon-stop-circle-fill t-iconfont" />
            </div>
          </el-tooltip>
        </template>

        <div v-else :class="{ disabled: polishLoading }" style="display: flex">
          <AiPolish
            ref="aiPolishRef"
            :disabled="isEmpty"
            :params="polishParams"
            @end="handlePolishEnd"
            @start="handlePolishStart"
            @success="handlePolishSuccess"
            @withdraw="handleWithdrawPolish"
          />
          <el-tooltip
            ref="wordLimitTooltipRef"
            content="可输入文本已达上限"
            :disabled="!isWordLimit || polishLoading"
            effect="dark"
            placement="top"
          >
            <div
              class="send-btn send-btn--active"
              :class="{ disabled: isEmpty || polishLoading }"
              @click="handleSend"
            >
              <i class="icon-arrow-up-line t-iconfont" />
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, nextTick, onMounted, useTemplateRef } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
// import CustomerSelect from '@/components/CustomerSelect.vue'
import CustomerSelectDialog from '@/components/ai-customer-select/index'
import AiCondition from '@/components/ai-condition/index.vue'
import AiPolish from '@/components/ai-polish/index.vue'
// import { getCustomRecordInfo, getCustomPromptTemplateList } from '@/api'
import { getCustomPromptTemplateList, getMeetingAssistantConfig } from '@/api'
import { useOSS } from '@/utils/oss'
// import xbbSdk from 'xbb-sdk'
import DialogCommonUsed from './DialogCommonUsed.vue'
import UploadedFileCard from '@/components/upload/UploadedFileCard.vue'
import AiPersonSelectV2 from '@/components/ai-person-select-v2/index.vue'
import {
  ENUM_BUSINESS_TYPE,
  ENUM_BUSINESS_TYPE_ENTRIES
} from '@/components/ai-customer-select/enum.ai-business-select.js'

defineOptions({
  name: 'ChatInputPanel'
})

const props = defineProps({
  // 是否可发送
  canSend: Boolean,
  // 快捷日期
  shortcuts: Array,
  // 字数限制
  wordLimit: Number,
  // 聊天提示列表
  chatTipsList: Array,
  // 当前选中的聊天提示索引
  currentIndex: Number,
  // 助手ID
  assistantId: {
    type: [String, Number],
    default: ''
  },
  // 是否是首页
  isHomepage: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits([
  'select-template',
  'show-more',
  'send',
  'resetAnalyzeModelAndFormat',
  'setPrompt'
])

// 分析内容
const analystContentModel = defineModel('analystContent', { type: String, default: '' })
// 客户
const customerModel = defineModel('customer', { type: Array, default: () => [] })
// 成员/部门选择的值(默认1表示全部部门)
const selectValueModel = defineModel('selectValue', { type: Array, default: () => [] })
// 日期范围
const dateScopeModel = defineModel('dateScope', { type: Array, default: () => [] })
const dateRangeDisplayText = computed(() => {
  if (!Array.isArray(dateScopeModel.value) || dateScopeModel.value.length < 2) return ''

  const [startTime, endTime] = dateScopeModel.value
  if (!startTime || !endTime) return ''

  return `${dayjs(startTime).format('YYYY-MM-DD')} ～ ${dayjs(endTime).format('YYYY-MM-DD')}`
})
// 分析类型（员工分析 0 & 客户100/线索8000/商机301 分析）
const analysisBusinessTypeModel = defineModel('analysisBusinessType', { type: Number })
// 是否联网
const enableSearchModel = defineModel('enableSearch', { type: Boolean, default: false })

// 是否走业务数据选择
const isBusinessTypeDataSource = computed(() => {
  return [
    ENUM_BUSINESS_TYPE.CUSTOMER.businessType,
    ENUM_BUSINESS_TYPE.CLUE.businessType,
    ENUM_BUSINESS_TYPE.CHANCE.businessType
  ].includes(analysisBusinessTypeModel.value)
})

// 加载状态
const loading = ref(false)
// 常用提示词列表
const commonUsedPromptList = ref([])
const aiPolishRef = ref(null)
const polishLoading = ref(false)
const lastOriginalPrompt = ref('')
const uploadLoading = ref(false)
const uploadedFiles = ref([])
const uploadInputRef = ref(null)
const uploadSize = ref(1)
const isWhite = ref(false)
const { uploadFile } = useOSS()
const UPLOAD_EXTENSIONS = ['pdf', 'doc', 'docx', 'md', 'png', 'jpg', 'jpeg']
const UPLOAD_TEXT = UPLOAD_EXTENSIONS.map((item) => item.toLocaleUpperCase()).join(',')
const UPLOAD_ACCEPT = UPLOAD_EXTENSIONS.map((item) => `.${item}`).join(',')
// 输入内容是否为空
const isEmpty = computed(() => !analystContentModel.value.trim())
const polishParams = computed(() => ({
  sceneType: 1,
  userPrompt: analystContentModel.value
}))
// 是否超出字数限制
const isWordLimit = computed(() => analystContentModel.value.length >= props.wordLimit)
// 我的常用弹窗显示状态
const isShowMyCommon = ref(false)
// 分页信息
const pageHelper = ref({
  page: 1,
  pageSize: 20
})
// 模板列表容器引用
const templateListWrapperRef = ref(null)
// 存储所有已加载的数据
const allPromptList = ref([])
// 是否显示右翻页按钮
const canPageRight = ref(false)
// 是否显示左翻页按钮
const canPageLeft = ref(false)
// 模板项的固定宽度
const TEMPLATE_ITEM_WIDTH = 142
const FILE_CARD_WIDTH = 408
// 翻页动画时长（毫秒）
const SCROLL_DURATION = 300
// 是否正在翻页中
const isPageChanging = ref(false)
const uploadedFileListRef = ref(null)
const canFilePageLeft = ref(false)
const canFilePageRight = ref(false)
const isFilePageChanging = ref(false)
// 分析类别
const analysisBusinessTypeOptions = [
  {
    label: '员工分析',
    value: 0
  },
  {
    label: '客户分析',
    value: ENUM_BUSINESS_TYPE.CUSTOMER.businessType
  },
  {
    label: '线索分析',
    value: ENUM_BUSINESS_TYPE.CLUE.businessType
  },
  {
    label: '机会分析',
    value: ENUM_BUSINESS_TYPE.CHANCE.businessType
  },
  {
    label: '陪练分析',
    value: 1
  }
]

const initList = () => {
  commonUsedPromptList.value = []
  allPromptList.value = []
  pageHelper.value = {
    page: 1,
    pageSize: 20
  }
  getTheCustomPromptTemplateList()
}

/**
 * 获取常用提示词列表
 */
const getTheCustomPromptTemplateList = async () => {
  try {
    const { result } = await getCustomPromptTemplateList({
      ...pageHelper.value,
      pageSize: 20
    })
    commonUsedPromptList.value = result?.dataList || []
    // 存储所有请求的不重复数据
    allPromptList.value = [...new Set([...allPromptList.value, ...commonUsedPromptList.value])]

    pageHelper.value = result?.pageHelper || {}
    pageHelper.value.page = pageHelper.value?.currentPage || 1
  } catch (error) {
    console.error(error)
  } finally {
    // 数据加载完成后更新翻页按钮状态
    nextTick(() => updatePageButtons())
  }
}

/**
 * 更新翻页按钮状态
 */
const updatePageButtons = () => {
  const container = templateListWrapperRef.value
  if (!container) return

  const scrollLeft = container.scrollLeft
  const maxScrollLeft = container.scrollWidth - container.clientWidth

  // 更新左翻页按钮：如果不在最左端就可以左翻
  canPageLeft.value = scrollLeft > 0

  // 更新右翻页按钮：如果不在最右端或者有下一页数据就可以右翻
  const hasNextPage = pageHelper.value?.rightPageNums?.length > 0
  canPageRight.value = scrollLeft < maxScrollLeft - 1 || hasNextPage
}

/**
 * 翻页处理入口
 * @param {boolean} direction - 翻页方向(true:右翻页；false:左翻页)
 */
const handlePageChange = async (direction) => {
  // 防止连续快速点击
  if (isPageChanging.value) return

  const container = templateListWrapperRef.value
  if (!container) return

  isPageChanging.value = true

  try {
    if (direction) {
      await handleRightPageChange(container)
    } else {
      await handleLeftPageChange(container)
    }
  } catch (error) {
    console.error('翻页操作失败:', error)
  } finally {
    // 延迟重置翻页状态，给动画留出时间
    setTimeout(() => {
      isPageChanging.value = false
    }, SCROLL_DURATION)
  }
}

/**
 * 处理右翻页
 */
const handleRightPageChange = async (container) => {
  const maxScrollLeft = container.scrollWidth - container.clientWidth
  const isAtRightEnd = container.scrollLeft >= maxScrollLeft - 1 // 允许1px误差
  const hasNextPage = pageHelper.value?.rightPageNums?.length > 0

  // 到达最右端
  if (isAtRightEnd) {
    if (hasNextPage) {
      // 加载下一页数据
      pageHelper.value.page++
      await getTheCustomPromptTemplateList()
      // 等待 Vue 的响应式更新完成后再执行依赖 DOM 状态的操作
      await new Promise((resolve) => setTimeout(resolve, 50))
    } else {
      // 没有更多数据，不执行滚动
      return
    }
  }

  // 执行平滑滚动
  container.scrollBy({
    left: TEMPLATE_ITEM_WIDTH,
    behavior: 'smooth'
  })

  // 等待滚动动画完成后再更新按钮状态
  setTimeout(() => {
    updatePageButtons()
  }, SCROLL_DURATION)
}

/**
 * 处理左翻页
 */
const handleLeftPageChange = async (container) => {
  // 检查是否可以左翻页
  if (!canPageLeft.value) {
    return
  }

  // 执行平滑滚动
  container.scrollBy({
    left: -TEMPLATE_ITEM_WIDTH,
    behavior: 'smooth'
  })

  // 等待滚动动画完成后再更新按钮状态
  setTimeout(() => {
    updatePageButtons()
  }, SCROLL_DURATION)
}

const updateFilePageButton = () => {
  const container = uploadedFileListRef.value
  if (!container) return

  const maxScrollLeft = container.scrollWidth - container.clientWidth
  canFilePageLeft.value = container.scrollLeft > 0
  canFilePageRight.value = container.scrollLeft < maxScrollLeft - 1
}

const handleFilePageChange = (direction) => {
  const canPage = direction > 0 ? canFilePageRight.value : canFilePageLeft.value
  if (isFilePageChanging.value || !canPage) return

  const container = uploadedFileListRef.value
  if (!container) return

  isFilePageChanging.value = true
  container.scrollBy({
    left: FILE_CARD_WIDTH * direction,
    behavior: 'smooth'
  })

  setTimeout(() => {
    updateFilePageButton()
    isFilePageChanging.value = false
  }, SCROLL_DURATION)
}

const handleFilePageLeft = () => {
  handleFilePageChange(-1)
}

const handleFilePageRight = () => {
  handleFilePageChange(1)
}

// 监听isEmpty的变化，当为空时重置分析模式为默认值
watch(isEmpty, (newVal) => {
  if (newVal) {
    emits('resetAnalyzeModelAndFormat')
  }
})

// 监听计算属性isWordLimit的变化，显示或隐藏提示
watch(isWordLimit, (newVal) => {
  if (newVal) {
    nextTick(() => {
      wordLimitTooltipRef.value?.onOpen()
      setTimeout(() => {
        wordLimitTooltipRef.value?.onClose()
      }, 3000)
    })
  }
})

/**
 * 处理发送
 */
const handleSend = () => {
  if (polishLoading.value || (props.canSend && isEmpty.value)) return
  if (props.canSend && uploadLoading.value) {
    ElMessage.warning('文件上传中，请稍后发送')
    return
  }
  emits('send')
}

const elInputRef = useTemplateRef('elInputRef')

// 默认高度，禁止修改
const skeletonHeight = ref(63)
const handlePolishStart = () => {
  // 这里拿到textara的高度，然后给骨架屏
  skeletonHeight.value = elInputRef.value.textarea.offsetHeight
  polishLoading.value = true
}

const handlePolishEnd = () => {
  polishLoading.value = false
}

const handlePolishSuccess = (result) => {
  if (!result) return
  lastOriginalPrompt.value = analystContentModel.value
  analystContentModel.value = result
}

const handleWithdrawPolish = () => {
  if (!lastOriginalPrompt.value) return
  analystContentModel.value = lastOriginalPrompt.value
  lastOriginalPrompt.value = ''
}
// 当前仅判断AI润色过的提示词后
const checkChangeAiPrompt = (value) => {
  if (aiPolishRef.value?.success && lastOriginalPrompt.value !== value) {
    aiPolishRef.value.reset()
  }
}

const getFileExt = (fileNameValue = '') => {
  const lastDotIndex = fileNameValue.lastIndexOf('.')
  return lastDotIndex > -1 ? fileNameValue.slice(lastDotIndex + 1).toLowerCase() : ''
}

const getCurrentTotalSize = () => {
  return uploadedFiles.value.reduce((total, file) => total + (file.size || 0), 0)
}

const validateUploadFile = (file, selectedTotalSize = 0) => {
  const ext = getFileExt(file.name)
  if (!UPLOAD_EXTENSIONS.includes(ext)) {
    return `仅支持 ${UPLOAD_TEXT} 格式`
  }
  if (getCurrentTotalSize() + selectedTotalSize + file.size > uploadSize.value * 1024 * 1024) {
    return `总文件大小不能超过 ${uploadSize.value}MB`
  }

  return ''
}

const createUploadingFile = (rawFile) => ({
  id: `upload-file-${Date.now()}-${Math.random().toString(36).slice(2)}`,
  filename: rawFile.name,
  size: rawFile.size,
  ext: getFileExt(rawFile.name)
})

const uploadSingleFile = async (fileItem, rawFile) => {
  try {
    const attachIndex = await uploadFile(rawFile)
    uploadedFiles.value = uploadedFiles.value.map((item) =>
      item.id === fileItem.id
        ? {
            attachIndex,
            filename: item.filename,
            size: item.size,
            ext: item.ext
          }
        : item
    )
  } catch (error) {
    uploadedFiles.value = uploadedFiles.value.filter((item) => item.id !== fileItem.id)
    ElMessage.error(error?.message || '文件上传失败，请稍后重试')
  }
}

const uploadRawFiles = async (files) => {
  const rawFiles = Array.from(files || [])
  if (!rawFiles.length) return

  const validFiles = []
  let selectedTotalSize = 0
  rawFiles.forEach((rawFile) => {
    const errorMessage = validateUploadFile(rawFile, selectedTotalSize)
    if (errorMessage) {
      ElMessage.error(errorMessage)
      return
    }
    validFiles.push(rawFile)
    selectedTotalSize += rawFile.size
  })
  if (!validFiles.length) return

  uploadLoading.value = true
  const uploadItems = validFiles.map(createUploadingFile)
  uploadedFiles.value = [...uploadedFiles.value, ...uploadItems]
  nextTick(() => updateFilePageButton())
  try {
    await Promise.all(
      uploadItems.map((fileItem, index) => uploadSingleFile(fileItem, validFiles[index]))
    )
    nextTick(() => updateFilePageButton())
  } finally {
    uploadLoading.value = false
  }
}

const handleUploadInputChange = async (event) => {
  await uploadRawFiles(event.target.files)
  event.target.value = ''
}

const clearUploadedFile = () => {
  uploadedFiles.value = []
  uploadLoading.value = false
  canFilePageLeft.value = false
  canFilePageRight.value = false
}

const handleDeleteUploadedFile = (file) => {
  uploadedFiles.value = uploadedFiles.value.filter((item) => item.attachIndex !== file.attachIndex)
  nextTick(() => updateFilePageButton())
}

const clickUpload = () => {
  if (!props.canSend || uploadLoading.value) return
  uploadInputRef.value?.click()
}

const canUploadFile = computed(() => props.canSend && !uploadLoading.value)

/**
 * 处理选择常用提示词
 * @param prompt 选中的提示词
 */
const handleSetPrompt = (prompt) => {
  emits('setPrompt', prompt)
  isShowMyCommon.value = false
}

const toggleNetworkEnabled = () => {
  enableSearchModel.value = !enableSearchModel.value
}
/**
 * 打开常用提示词弹窗
 */
const handleOpenCommonDialog = () => {
  isShowMyCommon.value = true
}
/**
 * 禁用未来时间
 * @param time 时间
 */
const disabledDate = (time) => {
  return time.getTime() > Date.now()
}
/**
 * 获取新建客户跟进记录需要的信息
 * @param type 业务类型
 */
// const getTheCustomRecordInfo = async (type) => {
//   const res = await getCustomRecordInfo({ businessType: type })
//   const { appId, menuId, formId, businessType, subBusinessType } = res.result
//   return { appId, menuId, formId, businessType, subBusinessType }
// }

const wordLimitTooltipRef = ref(null)
// const sendXbbParams = ref({})
// const customerSelectRef = ref(null)

const HOMEPAGE_TIPS_ENUM = {
  8000: '分析我最近跟进线索的转化卡点，给出下一步行动建议。',
  100: '分析我最近跟进客户的成单卡点，给出下一步行动建议。',
  301: '分析我最近跟进销售机会的成单卡点，给出下一步行动建议。',
  0: '分析下团队最近跟进的情况',
  1: '分析一下团队最近陪练的情况，总结出优秀话术'
}

/**
 * 切换分析类别（员工分析 0 & 业务分析 businessType）
 */
const switchAnalysisBusinessType = (val) => {
  analysisBusinessTypeModel.value = val
  const businessName = ENUM_BUSINESS_TYPE_ENTRIES[val]?.memo || '数据'
  customerModel.value = [
    {
      name: `全部${businessName}`,
      id: 0
    }
  ]
  if (props.isHomepage) {
    analystContentModel.value = HOMEPAGE_TIPS_ENUM[val] || ''
  }
}

/**
 * 新建客户
 */
// const handleAddCustomer = async () => {
//   const params = await getTheCustomRecordInfo(100)
//   sendXbbParams.value = {
//     appId: params.appId,
//     menuId: params.menuId,
//     formId: params.formId,
//     saasMark: 1,
//     businessType: params.businessType,
//     subBusinessType: params.subBusinessType
//   }
//   xbbSdk.sendMessage('addNewForm', {
//     appId: params.appId,
//     menuId: params.menuId,
//     formId: params.formId,
//     saasMark: 1,
//     businessType: params.businessType,
//     subBusinessType: params.subBusinessType
//   })
//   customerSelectRef.value.dropdownRef.handleClose()
// }
const selectTemplate = (val) => {
  emits('setPrompt', {
    prompt: val.content,
    title: val.name,
    outputFormat: val.outputFormat,
    analyzeModel: val.analyzeModel
  })
}

onMounted(() => {
  try {
    loading.value = true
    if (props.isHomepage && analysisBusinessTypeModel.value !== undefined) {
      switchAnalysisBusinessType(analysisBusinessTypeModel.value)
    }
    initList()
    // 是否是白名单企业，白名单企业显示上传文件按钮
    getIsWhiteCorp()
    // 初始化翻页按钮状态
    nextTick(() => updatePageButtons())
    nextTick(() => updateFilePageButton())
  } catch (error) {
    console.error('AI分析师初始化失败：', error)
  } finally {
    loading.value = false
  }
})

defineExpose({
  initList,
  uploadedFiles,
  uploadSize,
  uploadText: UPLOAD_TEXT,
  clearUploadedFile,
  uploadRawFiles,
  canUploadFile
})

// 白名单
const getIsWhiteCorp = () => {
  getMeetingAssistantConfig({
    type: 12
  }).then((res) => {
    if (res.result?.data?.config) {
      const data = JSON.parse(res.result.data.config)
      isWhite.value = data.enable
      if (data.fileSize) {
        uploadSize.value = data.fileSize
      }
    }
  })
}

const keydownChatInput = (e) => {
  if (e.keyCode !== 13 || e.keyCode === 229) return

  if (e.ctrlKey || e.metaKey) {
    e.preventDefault()
    analystContentModel.value += '\n'
    return
  }

  e.preventDefault()
  handleSend()
}
</script>

<style scoped lang="less">
@text-main: #323233;
@text-auxiliary: #969799;
@violets-color-6: #7a52f4;
@font-family: PingFang SC;

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  --el-checkbox-checked-bg-color: @violets-color-6;
  --el-checkbox-checked-input-border-color: @violets-color-6;
}
:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  --el-checkbox-checked-text-color: @text-main;
}

.chat-input-panel {
  width: 100%;
  position: relative;
}

.main {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 12px 12px 6px 12px;
  box-sizing: border-box;
}
.word-count {
  width: 100%;
  height: 20px;

  &--text {
    font-family: @font-family;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    text-align: right;
    letter-spacing: 0em;
    z-index: 1;
    color: @text-auxiliary;
    padding-right: 8px;
  }

  &--red {
    color: #f54e4e;
  }
}

.template-header {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: @text-auxiliary;
  margin-bottom: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.not-allow {
  cursor: not-allowed !important;
}

.template-list {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 8px;
  width: 100%;

  .template-list-wrapper {
    display: flex;
    gap: 12px;
    // position: relative;
    width: 590px;
    overflow-x: auto;
    scroll-behavior: smooth;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
    /* Chrome/Safari/Opera */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.top-block {
  display: flex;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 76px;
  top: -76px;
  padding-top: 12px;
  background: linear-gradient(180deg, rgba(247, 248, 250, 0) 0%, #f7f8fa 80%);
}

.template-item {
  max-width: 220px;
  height: 36px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #e5e6eb;
  transition: all 0.3s ease;
  cursor: pointer;

  .ellipsis {
    // width: 170px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .more-text {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    color: #969799;
  }

  .icon-sparkling-2-line {
    color: #969799;
  }

  &:nth-child(3) {
    width: 130px;
  }
}

.template-item:not(.disabled):hover,
.active-item {
  background: linear-gradient(97deg, #e9ecfa 0%, #dfeeff 100%);
  border: 1px solid #5952ff;
}

.template-item.disabled {
  color: @text-auxiliary;
  cursor: not-allowed;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 36px;

  &--left {
    justify-content: flex-end;
    position: absolute;
    left: 0;
    background: linear-gradient(90deg, #f7f8fa 0%, rgba(247, 248, 250, 0) 100%);
  }
  &--right {
    position: absolute;
    right: 210px;
    background: linear-gradient(270deg, #f7f8fa 0%, rgba(247, 248, 250, 0) 100%);
  }

  &__icon {
    width: 24px;
    height: 24px;
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #e5e6eb;
    box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    &:hover {
      color: #7a52f4;
      border: 1px solid #7a52f4;
      box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.1);
    }
  }
  &--hidden {
    visibility: hidden;
  }
  &--disabled {
    pointer-events: none;
  }
  &__icon--disabled {
    cursor: not-allowed !important;
  }
}

.more {
  display: flex;
  align-items: center;

  .icon-expand-diagonal-line {
    box-sizing: border-box;
    max-width: 36px;
    max-height: 36px;
    cursor: pointer;
    padding: 10px;

    &:hover {
      border-radius: 12px;
      padding: 10px;
      background: #e5e6eb;
      color: #323233;
    }
  }

  .line {
    height: 16px;
    border-right: 1px solid #e5e6eb;
    margin: 0 12px;
  }
}

.colorful-text {
  background: linear-gradient(90deg, #1574ff, #5952ff, #a969fe);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.content-input {
  width: 100%;
}

.uploaded-file-strip {
  position: relative;
  margin: -8px -8px 0 0;
}

.uploaded-file-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  padding: 8px 8px 8px 0;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.uploaded-file-page-btn {
  position: absolute;
  top: 8px;
  display: flex;
  align-items: center;
  width: 48px;
  height: 54px;
  pointer-events: none;

  &--left {
    left: 0;
    justify-content: flex-start;
    background: linear-gradient(90deg, #ffffff 42%, rgba(255, 255, 255, 0) 100%);
  }

  &--right {
    right: 0;
    justify-content: flex-end;
    background: linear-gradient(270deg, #ffffff 42%, rgba(255, 255, 255, 0) 100%);
  }

  &--hidden {
    visibility: hidden;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    border: 1px solid #e5e6eb;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.1);
    color: #323233;
    cursor: pointer;
    pointer-events: auto;

    &:hover {
      border-color: #7a52f4;
      color: #7a52f4;
    }
  }

  &__icon--disabled {
    cursor: not-allowed;
  }
}

.content-skeleton {
  width: 100%;
  height: 63px;
  &__rows {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__row {
    width: 100%;
    height: 23px;
    border-radius: 8px;

    &--short {
      width: 72%;
    }
  }
}

:deep(.content-input .el-textarea__inner) {
  border: none !important;
  box-shadow: none !important;
  resize: none;
  padding: 0;
}

.input-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
  flex: 1;
}

.filter-section {
  display: flex;
  align-items: center;
  flex: 1;
  overflow: scroll;
  margin-right: 12px;
  .filter-section-left {
    display: flex;
    gap: 8px;
    flex: 1;
    align-items: center;

    .filter-section__item {
      box-sizing: border-box;

      :deep(.el-date-editor .el-range__icon) {
        color: unset;
      }

      &:hover {
        color: @violets-color-6;
      }

      &:hover .date-range-picker__display {
        color: @violets-color-6;
      }
    }
    .upload-btn {
      width: 32px;
      height: 32px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .icon-add-line {
        color: #323233;
        font-size: 20px;
      }
      &:hover {
        background: #f2f3f5;
      }
    }
    .deco {
      height: 16px;
      width: 1px;
      background-color: #f2f3f5;
    }
    .network-btn {
      height: 32px;
      padding: 0 12px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      box-sizing: border-box;
      border-radius: 12px;
      border: 1px solid #e5e6eb;
      background: #ffffff;
      color: #646566;
      font-size: 14px;
      line-height: 1;
      cursor: pointer;
      transition: all 0.2s ease;
      white-space: nowrap;

      &:hover {
        border-color: @violets-color-6;
        color: @violets-color-6;
        background: #f5e8ff;
      }

      &.active {
        border-color: @violets-color-6;
        color: @violets-color-6;
        background: #f5e8ff;
      }

      .t-iconfont {
        font-size: 16px !important;
      }
    }

    .button-switch {
      margin-right: 8px;
      display: flex;
      align-items: center;
      border-radius: 12px;
      background: #f2f3f5;
      padding: 2px;
      gap: 4px;
      box-sizing: border-box;
      height: 36px;
      &__item {
        height: 32px;
        box-sizing: border-box;
        line-height: 20px;
        padding: 4px 12px;
        display: block;
        white-space: nowrap;
        border-radius: 10px;
        font-size: 14px;
        border: none;
        color: #646566;
        background: transparent;

        &.active {
          color: #323233;
          background: #ffffff;
        }
        &:hover {
          color: #323233;
          // background: #ffffff;
          cursor: pointer;
          opacity: 0.85;
        }
      }
    }
  }

  :deep(.el-date-editor) {
    width: 212px;
  }

  .condition-bg {
    background: transparent;
  }
}

.active {
  color: @violets-color-6;
  background: #f5e8ff;
  border-color: @violets-color-6;
  --el-button-active-border-color: @violets-color-6 !important;
  --el-button-active-bg-color: #f5e8ff !important;
  --el-button-active-text-color: @violets-color-6 !important;
}

:deep(.el-date-editor) {
  min-width: 234px;
  max-width: 300px;
}

// :deep(.customer-select) {
//   min-width: 96px;
//   flex: none;
// }

:deep(.el-input__wrapper) {
  box-shadow: unset;
}

:deep(.el-date-editor.el-input__wrapper) {
  box-shadow: unset;
}

.date-range-picker {
  position: relative;
  width: 100%;

  :deep(.el-date-editor) {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }

  &__display {
    position: absolute;
    width: 80px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 20px;
    z-index: 1;
    display: block;
    overflow: hidden;
    padding: 6px 4px 6px 0;
    color: @text-main;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
    pointer-events: none;
  }

  &--has-value {
    :deep(.el-range-input),
    :deep(.el-range-separator) {
      opacity: 0;
    }
  }
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}
.send-btn {
  cursor: pointer;
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  transition: all 0.3s ease;

  &--active {
    background: linear-gradient(306deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
  }
}
.icon-arrow-up-line {
  color: #fff;
  font-size: 20px !important;
}
.t-iconfont {
  font-size: 16px;
}
.icon-send-plane-fill {
  color: #fff;
}
.icon-stop-circle-fill {
  color: #646566;
}

/* 淡入淡出动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
